/* #region(collapsed) DEVELOPER DOCUMENTATION ════════════════════════════════════ */
/**
  @license
  • COPYRIGHT NOTICE:
    © CROUIN 2021. All rights reserved. Powered by MaxDesign.
    ⚠ FR : CONTENU PROTÉGÉ PAR LES DROITS D'AUTEURS (article L. 111-1 du code de la propriété intellectuelle). Cette ressource ne peut pas être utilisée, diffusée ou exploitée sans l'approbation de ses auteurs. Pour plus d'informations, veuillez contacter admin(at)maxdesign.expert
    ⚠ EN : CONTENT PROTECTED WITH AUTHOR COPYRIGHTS (section L. 111-1 of the intellectual property code). This resource may not be used, distributed or exploited without the approval of its authors. For any information request, please contact admin(at)maxdesign.expert
 
  • INTRODUCTION:
    Code powered by MaxDesign.
    This code uses HTML custom element shipping-estimate-maxdesign.
    Custom elements extend HTML by creating new elements that carry their own JavaScript for adding new behavior.
 
  • MORE INFORMATION:
    Contact us at admin(at)maxdesign.expert
*/
/* #endregion ════════════════════════════════════════════════════════════════════ */

class DeliveryEstimation extends HTMLElement {
  connectedCallback() {
    Object.assign(this, JSON.parse(this.querySelector(':scope > [type="application/json"]').innerText));
    this.mainPlaceholder = this.querySelector('[data-shipping-estimate]');
    this.flagPlaceholder = this.querySelector('[data-shipping-flag]');
    if (this.mainPlaceholder) this.shippingEstimate().then(result => (this.mainPlaceholder.textContent = result));
    if (this.flagPlaceholder) this.getFlag().then(result => (this.flagPlaceholder.innerHTML = result));
  }

  /* shipping estimate */
  shippingEstimate() {
    const { delayMin, delayMax, weekday, skipSat, skipSun, skipHol, language, country } = this;
    const date = new Date();
    const year = date.getFullYear();
    const locales = `${language}-${country}`;

    const addDays = (date, days) => {
      const newDate = new Date(date);
      while (days > 0) {
        newDate.setDate(newDate.getDate() + 1);
        const dayIndex = newDate.getDay();
        if ((skipSun && dayIndex === 0) || (skipSat && dayIndex === 6)) continue;
        days--;
      }
      return newDate;
    };

    const getDay = (date, holidays) => {
      const isHoliday = holidays?.some(item => item.date == date.toISOString().slice(0, 10));
      return isHoliday ? addDays(date, 1) : date;
    };

    const fetchHolidays = async () => {
      const response = await Promise.race([
        fetch(`https://date.nager.at/api/v3/publicholidays/${year}/${country}`),
        new Promise((_, reject) => setTimeout(() => reject(new Error('date.nager api fetch request timed out')), 300)),
      ]);
      const holidays = await response.json();
      if (holidays.errors) throw holidays.errors;
      return holidays;
    };

    const getDeliveryDate = async () => {
      let start, end;
      try {
        const holidays = skipHol ? await fetchHolidays() : null;
        start = getDay(addDays(date, delayMin), holidays);
        end = getDay(addDays(date, delayMax), holidays);
      } catch (error) {
        console.error(error);
        start = getDay(addDays(date, delayMin));
        end = getDay(addDays(date, delayMax));
      }
      const formatOptions = {
        weekday: weekday ? 'short' : undefined,
        day: '2-digit',
        month: start.getMonth() != end.getMonth() || weekday ? 'short' : undefined,
      };
      const startFormat = start.toLocaleDateString(locales, formatOptions);
      const endFormat = end.toLocaleDateString(locales, { ...formatOptions, month: 'short' });
      return start.getDate() != end.getDate() ? `${startFormat} - ${endFormat}` : `${endFormat}`;
    };

    return getDeliveryDate();
  }

  /* flag placehodler */
  async getFlag() {
    const response = await fetch(`${Shopify.routes.root || '/'}browsing_context_suggestions.json`);
    const data = await response.json();
    const flag = data?.detected_values?.country?.handle;
    if (!flag) return;
    return `&puncsp;<img src="//cdn.shopify.com/static/images/flags/${flag.toLowerCase()}.svg?width=30">`;
  }
}
customElements.define('shipping-estimate-maxdesign', DeliveryEstimation);
